import { ChatMessageOrigin, ChatMessageType } from "./types";
import { EntityType } from "api/ux/src";
import { language } from "language/default";
export const assistantChartPrefix = "assistant_chart_";
// eslint-disable-next-line no-magic-numbers
export const getRandomChartId = () => `${assistantChartPrefix}${Math.random().toString(36)
    .substring(2, 6)}`;
const parsePlugin = (plugin) => {
    switch (plugin) {
        case "portfolio_analytics":
            return EntityType.Portfolio;
        case "fund_analytics":
            return EntityType.Fund;
        case "asset_analytics":
            return EntityType.Asset;
        case "manager_analytics":
            return EntityType.Manager;
        default:
            return undefined;
    }
};
export const getChatFromChunk = (chunk) => {
    const chatMessage = {
        date: new Date(),
        origin: ChatMessageOrigin.SERVER,
        targetEntity: parsePlugin(chunk.plugin)
    };
    switch (chunk.type) {
        case "answer":
            chatMessage.content = { chartDefinition: chunk.data };
            chatMessage.type = ChatMessageType.CHART;
            break;
        case "suggestion":
            chatMessage.content = { suggestionQuestion: chunk.data.text };
            chatMessage.type = ChatMessageType.SUGGESTION;
            break;
        case "update":
            chatMessage.content = { chartDefinition: chunk.data };
            chatMessage.type = ChatMessageType.UPDATE;
            break;
        case "text":
            chatMessage.content = { message: chunk.data.text };
            chatMessage.type = ChatMessageType.TEXT;
            break;
        case "system":
            chatMessage.content = { message: language.en.analyticsAssistant.serverError };
            chatMessage.type = ChatMessageType.ERROR;
            break;
        default:
            chatMessage.content = { message: chunk.data.text };
            chatMessage.type = chunk.type === "error" ? ChatMessageType.ERROR : ChatMessageType.INFO;
    }
    return chatMessage;
};
